import * as z from 'zod'

export const StockType = z.enum(['stocks', 'rest_vials', 'returns', 'discards'])
export type StockType = z.infer<typeof StockType>

export const StocksFiltersSchema = z.object({
  search: z.string().optional(),
})
export type StocksFiltersSchema = z.infer<typeof StocksFiltersSchema>
